<div class="d-flex">
  <h1 class="page-title me-auto">Reports</h1>
  <lib-search *ngIf="!isClientPortal"></lib-search>
</div>
<ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="active">
  <li [ngbNavItem]="1">
    <a ngbNavLink class="tab-title">Recurring</a>
    <ng-template ngbNavContent>
      <lib-recurring-reports [clientCode]="clientCode"> </lib-recurring-reports>
    </ng-template>
  </li>
  <li [ngbNavItem]="2">
    <a ngbNavLink class="tab-title">On Demand</a>
    <ng-template ngbNavContent>
      <lib-on-demand-root [clientCode]="clientCode"></lib-on-demand-root>
    </ng-template>
  </li>
  <li [ngbNavItem]="3">
    <a ngbNavLink class="tab-title">Quarterly & Annual</a>
    <ng-template ngbNavContent>
      <lib-quarterly-reports (downloadClicked)="download($event)" [clientCode]="clientCode">
      </lib-quarterly-reports>
    </ng-template>
  </li>
  <li [ngbNavItem]="4">
    <a ngbNavLink class="tab-title">Paystub History</a>
    <ng-template ngbNavContent>
      <lib-paystub-history
        [activatedRoute]="activatedRoute"
        [clientCode]="clientCode"></lib-paystub-history>
    </ng-template>
  </li>
  <li [ngbNavItem]="5">
    <a ngbNavLink class="tab-title">Refunds & Debits</a>
    <ng-template ngbNavContent>
      <lib-credit-debit-memo></lib-credit-debit-memo>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
